export default __webpack_public_path__ + "static/media/kitchen3-afterH-768w.761089ec.avif";